import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { VpIcon } from '../VpIcon';
import { StyledVpInfoBanner } from './styles';

export const VpInfoBanner = ({ label = '', ...rest }) => {
  return (
    <StyledVpInfoBanner {...rest}>
      <VpIcon icon="Info" />
      <Typography variant="body2">{label}</Typography>
    </StyledVpInfoBanner>
  );
};

VpInfoBanner.propTypes = {
  label: PropTypes.string
};

export default VpInfoBanner;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpInfoBanner/VpInfoBanner.jsx